import { iAmVisitor } from '../../../../react/features/visitors/functions';
import { isXbees } from '../../../../x-bees/base/app/functions';
import { createVisitorEvent } from '../AnalyticsEvents';
import { sendStatsToKibana } from '../kibana/actions';
import { KIBANA_MESSAGES } from '../kibana/constants';
import { KINESIS_MESSAGES } from './constants';
export function isKinesisLogsEnabled(state) {
    return state['features/base/config']?.enableKinesisLogs === true;
}
export function normalizePbxHost(pbxHost, pbxUser, userId) {
    if (!pbxHost) {
        return '';
    }
    let host = pbxHost.replace(/https?:\/\//, '').replace(/:\d*$/, '');
    if (pbxUser && userId && /^[\d|.]*$/.test(host)) {
        host = `${userId.split('_')[1]}.wildixin.com`;
    }
    return host;
}
export function buildEventDataByFilter(event, store) {
    if (event.message) {
        return event;
    }
    let data = null;
    const fieldForAnalysis = event.source === 'toolbar.button'
        ? event.actionSubject
        : event.actionSubjectId || event.source || event.actionSubject || event.action;
    switch (fieldForAnalysis) {
        case 'raise.hand':
        case 'toggle.raise.hand':
            if (iAmVisitor(store.getState())) {
                data = {
                    message: `visitors: ${event.attributes.enable ? 'promotion request' : 'lowered hand'}`
                };
                store.dispatch(sendStatsToKibana([createVisitorEvent({
                        buttonName: event.attributes.enable ? 'visitors.promotion-request' : 'visitors.lowered-hand',
                        source: event.source
                    })], KIBANA_MESSAGES.Visitors));
            }
            else {
                data = {
                    message: event.attributes.enable ? KINESIS_MESSAGES.raiseHand : KINESIS_MESSAGES.lowerHand
                };
            }
            break;
        case 'reaction':
            data = {
                message: KINESIS_MESSAGES.reaction
            };
            break;
        case 'poll.created':
            data = {
                message: KINESIS_MESSAGES.pollCreated
            };
            break;
        case 'toggle.screen.sharing':
            data = {
                message: `${event.attributes.enable ? 'started' : 'stopped'} ${KINESIS_MESSAGES.screenSharing}`
            };
            break;
        case 'recording.file':
            data = {
                message: `${event.action} ${KINESIS_MESSAGES.recording}`
            };
            break;
        case 'recording.stream':
            data = {
                message: `${event.action} ${KINESIS_MESSAGES.liveStream}`
            };
            break;
        case 'remote.mute.button':
            data = {
                message: `${event.attributes.media_type === 'audio'
                    ? KINESIS_MESSAGES.muteParticipant
                    : KINESIS_MESSAGES.disableParticipantVideo}`,
                participantResource: event.attributes.participant_id
            };
            break;
        case 'visitors.admit':
            data = {
                message: `visitors: admit from ${event.source === 'notification'
                    ? 'notification' : 'participants pane'}`
            };
            break;
        case 'visitors.reject':
            data = {
                message: `visitors: reject from ${event.source === 'notification'
                    ? 'notification' : 'participants pane'}`
            };
            break;
        case 'visitors.admitAll':
            data = {
                message: 'visitors: admit all'
            };
            break;
        default:
    }
    return data;
}
export function getWildixPlatform(getState) {
    const state = getState();
    const { pbxUser, isWizyconfHW, appNamePlatform } = state['features/base/config'];
    if (isXbees(state)) {
        return normalizeRnaPlatform(appNamePlatform);
    }
    return pbxUser ? `wizyconf${isWizyconfHW ? ' hardware' : ''}` : 'wizyconf guest';
}
function normalizeRnaPlatform(name) {
    let platform = 'x-bees';
    switch (name) {
        case 'x-hoppers':
        case 'xhoppers': {
            platform = 'x-hoppers';
            break;
        }
        case 'x-bees':
        case 'xbees': {
            platform = 'x-bees';
            break;
        }
        case 'collaboration': {
            platform = 'collaboration';
            break;
        }
        case 'kite': {
            platform = 'kite';
            break;
        }
    }
    return platform;
}
